import { FC, useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { FeatureFlagId } from '../../api/ester-b2b-api/private/featureFlags/types'
import { useIsFeatureEnabled, useIsFeatureFlagsLoaded } from '../../state/selectors'

interface FeatureFlagGuardProps {
  flagId: FeatureFlagId
  redirectTo?: string
}

export const FeatureFlagGuard: FC<FeatureFlagGuardProps> = ({ flagId, redirectTo = '/portal' }) => {
  const navigate = useNavigate()
  const isLoaded = useIsFeatureFlagsLoaded()
  const isEnabled = useIsFeatureEnabled(flagId)

  useEffect(() => {
    if (isLoaded && !isEnabled) {
      navigate(redirectTo)
    }
  }, [isLoaded, isEnabled, navigate, redirectTo])

  if (!isLoaded) {
    return null
  }

  return isEnabled ? <Outlet /> : null
}
